/*
================================================
Une mixin qui gère la récupération initial de l'User et de son organisation.

IMPORTANT : Dans cette mixin this est le this du contexte de la mixin, self est le this global passé au constructeur des methods de la mixin.

https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/
var InitialHydrationMixin =  {
    created(){
    },

    data: function () {
        return {
        }
    },
    methods: {
        /**
         * Récupère les informations de l'utilisateur après son authentification
         */
        fetchUser: function(self) {

            self.$http.get(
                `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}`,
                {headers: {Authorization: self.$auth.header()}}
            )
                .then(function (response) {
                    // handle success
                    self.$store.commit('UpdateUser', response.data);
                    self.$store.commit('UpdateUserCurrentAccountEmail', response.data.email);

                    // On définit le workspace actif // @todo à dynamiser lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
                    // self.$store.commit('UpdateUserActiveWorkspace',response.data.workspaces[0]);

                })
                .catch(function (error) {
                    // handle error
                    // self.$store.commit('UpdateGlobalNotificationComp', {
                    //     'isVisible': true,
                    //     'color': 'is-danger',
                    //     'message': self.$t('ErrorFecthingInitialUser')
                    // });
                    console.warn(`Error 1001 retrieving initial user : ${error}`, 'error')

                    // on active sentry selon l'env (permet si besoin de conserver les erreurs en console en dev env si disabled)
                    if (process.env.VUE_APP_SENTRY_ENABLED=='true') {
                        self.$sentry.configureScope((scope) => {
                            scope.setTag("page_locale", self.$route.params.locale);
                            scope.setUser({"username": self.$auth.getUserSlug()});
                        })
                        self.$sentry.captureMessage(`Error 1001 retrieving initial user : ${error}`, 'error')
                    }
                })
                .then(function () {
                    // always executed
                });
        },

        /**
         * Récupère les informations de l'organization de l'utilisateur
         */
        fetchOrganizationUser: function(self) {

            // let self = this;
            self.$http.get(
                `organizations/${self.$auth.getOrganization()}`,
                {headers: {Authorization: self.$auth.header()}}
            )
                .then(function (response) {
                    // handle success
                    self.$store.commit('UpdateOrganization', response.data);
                })
                .catch(function (error) {
                    // handle error
                    // self.$store.commit('UpdateGlobalNotificationComp', {
                    //     'isVisible': true,
                    //     'color': 'is-danger',
                    //     'message': self.$t('ErrorFecthingInitialUserOrganization')
                    // });

                    console.warn(`Error 1002 retrieving initial organization : ${error}`, 'error')

                    // on active sentry selon l'env (permet si besoin de conserver les erreurs en console en dev env si disabled)
                    if (process.env.VUE_APP_SENTRY_ENABLED=='true') {
                        self.$sentry.configureScope((scope) => {
                            scope.setTag("page_locale", self.$route.params.locale);
                            scope.setUser({"username": self.$auth.getUserSlug()});
                        })
                        self.$sentry.captureMessage(`Error 1002 retrieving initial organization : ${error}`, 'error')
                    }
                })
                .then(function () {
                    // always executed
                });
        },


        /**
         * Requête l'api REST pour obtenir l'objet User et son Organization et les conserver dans le store.
         *
         * Cette récupération est effectuée si la valeur de $store.state.StoreInitToken. est vide. Après une récupération réussi on le remplit avec un timestamp. S'il est vide, suite à un rechargement de page par exemple on relance les méthodes fetchUser() et fetchOrganizationUser().
         *
         */
        userInitialHydration: function(self){
            if(self.$store.state.app.StoreInitToken === null){
                this.fetchUser(self);
                this.fetchOrganizationUser(self);
                self.$store.commit('UpdateAppStoreInitToken', (new Date().getTime()).toString(16));
                self.$store.commit('UpdateAppIsLoading', false);
            }
        }
    }

}

export default  InitialHydrationMixin;
